<template>
  <div class="histroy-box">
    <div class="histroy-slide">
      <div
        v-for="(item, index) in histroyNav"
        :class="showActiveIndex === index ? ['histroy-slide-msg', 'show-active'] : 'histroy-slide-msg'"
        :key="item.id"
        @click="slideIndex(index)"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="histroy-show" v-if="histroyList.length !== 0">
      <div
        v-for="(item) in histroyList"
        :key="item.id"
        :class="showActiveIndex === 0 ? ['histroy-img', 'histroy-used'] : ['histroy-img', 'histroy-expired']"
      >
        <div class="histroy-msg">
          <p class="histroy-msg-money">
            {{ item.userCouponAmount }}
          </p>
          <h3 class="histroy-msg-detail">
            <p>优惠券</p>
            <span class="histroy-msg-full">{{ item.userCouponDesc | specificCoupon(item.userCouponDesc) }}</span>
          </h3>
        </div>
        <span class="histroy-time">{{ item.userCouponEffectiveEndDate | convertTime(item.userCouponEffectiveEndDate) }}</span>
      </div>
    </div>
    <div class="histroy-no" v-else>
      <p>暂无数据</p>
    </div>
  </div>
</template>
<script>
import { getUsedCoupon, getFailCoupon } from '@/api/common.js'
import { formatTimeToStr } from '@/utils/date.js'
export default {
  name: 'couponModule',
  data() {
    return {
      histroyNav: [
        {
          id: 1,
          name: '已使用'
        },
        {
          id: 2,
          name: '已失效'
        }
      ],
      histroyImg: [
        {
          id: 1,
          list: []
        },
        {
          id: 2,
          list: []
        }
      ],
      showActiveIndex: 0,
      loading: true
    }
  },
  computed: {
    histroyList: {
      get() {
        return this.histroyImg.filter((item) => item.id === this.showActiveIndex + 1)[0].list
      },
      set(v) {
        return v
      }
    }
  },
  filters: {
    convertTime(time) {
      return '限至' + formatTimeToStr(time * 1000)
    },
    specificCoupon(str) {
      return str.substring(0, str.indexOf('减')) + '元可用'
    }
  },
  props: {
    userData: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
    this.slideIndex(this.showActiveIndex)
  },
  methods: {
    slideIndex(idx) {
      this.showActiveIndex = idx
      this.histroyList.splice(0, this.histroyList.length)
      if (idx === 0) {
        getUsedCoupon().then((res) => {
          if (res && res.code === 0) {
            res.data.map((list) => {
              this.histroyList.push(list)
            })
          }
        }).catch((err) => {
          this.$message({
            type: 'error',
            message: err.msg
          })
        })
      } else {
        getFailCoupon().then((res) => {
          if (res && res.code === 0) {
            res.data.map((list) => {
              this.histroyList.push(list)
            })
          }
        }).catch((err) => {
          this.$message({
            type: 'error',
            message: err.msg
          })
        })
      }
    }
  },
};
</script>
<style lang="less" scoped>
  .histroy-box {
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      display:none
    }
    .histroy-slide {
      width: 100%;
      display: flex;
      justify-content: space-between;
      .histroy-slide-msg {
        width: 50%;
        cursor: pointer;
        font-size: 20px;
        text-align: center;
        color: #303133;
        line-height: 60px;
      }
      .show-active {
        color: #409eff;
      }
    }
    .histroy-show {
      width: 100%;
      max-height: 490px;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      overflow: hidden;
      padding-left: 85px;
      padding-right: 90px;
      margin-top: 30px;
      overflow-y: scroll;
      // padding-bottom: 150px;
      &::-webkit-scrollbar {
        display:none
      }
      .histroy-img {
        width: 334px;
        height: 82px;
        margin-top: 15px;
        margin-right: 35px;
        position: relative;
        /deep/ &::-webkit-scrollbar {
          display:none
        }
        .histroy-msg {
          width: 200px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          margin: 0 auto;
          margin-left: 0px;
          height: 100%;
          position: relative;
          z-index: 1;
          .histroy-msg-money {
            margin: 0;
            font-size: 52px;
            font-weight: 700;
            color: #8b8b8b;
            line-height: 1;
            text-align: right;
          }
          .histroy-msg-detail {
            width: 82px;
            margin-left: 24px;
            text-align: center;
            p {
              font-weight: 700;
              margin: 0;
              color: #8b8b8b;
            }
            .histroy-msg-full {
              font-weight: normal;
              font-size: 14px;
              color: #8b8b8b;
            }
          }
        }
        img {
          max-width: 100%;
        }
        .histroy-time {
          position: absolute;
          right: 0;
          font-size: 12px;
          top: 67%;
          transform: translateY(-25%);
          transform: scale(0.85);
          color: #8b8b8b;
        }
      }
      .histroy-used {
        background: url("~@/assets/images/used-bg.png");
        background-size: contain;
        background-repeat: no-repeat;
      }
      .histroy-expired {
        background: url("~@/assets/images/expired-bg.png");
        background-size: contain;
        background-repeat: no-repeat;
      }
    }
    .histroy-no {
      width: 100%;
      text-align: center;
      font-size: 16px;
      color: #909399;
    }
  }
</style>